export default __webpack_public_path__ + "static/media/notification-bell.c6cadc4e.svg";